import Shimmer from '@app/components/shimmer/Shimmer';
const CalculatedResultsItemValue = ({ isLoading, item }) => {
    if (isLoading) {
        return <Shimmer className="rounded w-32 h-5"/>;
    }
    const { value, isMonthlyPaymentLimitExceeded } = item;
    if (isMonthlyPaymentLimitExceeded) {
        return <span className="text-critical-primary-initial">{value}</span>;
    }
    return <span>{value}</span>;
};
export default CalculatedResultsItemValue;
